var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrustcenter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.247,
    height: 27.46,
    viewBox: "0 0 20.247 27.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5730.313,3440.019c0-1.371-.007-2.823-.009-4.377-.005-1.273-.014-4.557-.014-4.694,0-4.412-4.1-8.015-9.178-8.015s-9.181,3.6-9.181,8.015v5.18h2.024v4.475h7.966v.936h-2.981v6.988H5730.3C5730.315,3447.326,5730.317,3444.331,5730.313,3440.019ZM5711,3437.061v-6.113c0-4.957,4.54-8.948,10.111-8.948s10.109,3.991,10.109,8.948c0,.135.009,3.418.014,4.691,0,1.555.007,3.007.009,4.38.007,5.063,0,8.294-.023,8.99l-.014.451h-15.38v-.933h2.183v-6.988h-4.985v-4.478Zm10.218-3.193a3.723,3.723,0,1,0-3.724-3.723A3.724,3.724,0,0,0,5721.218,3433.868Zm0,.931a4.654,4.654,0,1,1,4.654-4.654A4.653,4.653,0,0,1,5721.218,3434.8Zm-2.118-3.791a.465.465,0,1,1,.51-.777l1.047.684,1.878-2.45a.466.466,0,0,1,.738.568l-1.876,2.448a.935.935,0,0,1-1.25.214Z",
    transform: "translate(-5711 -3422)",
    fill: "#0080ff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustcenter);
export default __webpack_public_path__ + "static/media/trustcenter.f0cc9585.svg";
export { ForwardRef as ReactComponent };